import { render, staticRenderFns } from "./CoachContentLabel.vue?vue&type=template&id=d89a92d0&scoped=true&"
import script from "./CoachContentLabel.vue?vue&type=script&lang=js&"
export * from "./CoachContentLabel.vue?vue&type=script&lang=js&"
import style0 from "./CoachContentLabel.vue?vue&type=style&index=0&id=d89a92d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a92d0",
  null
  
)

export default component.exports